module.exports = __webpack_public_path__ + "static/flags/MB-5fd790538943423903f1aba6752480ed.gif";